/**
 * 区域选择器
 */
class RegionPicker extends HTMLElement {
  constructor() {
    super();
    this.countryItemNodes = [];
    this.regionDesktopButtons = [];
    this.countriesListNode = null;
    this.openClass = 'locale-modal-mobile-open';
    this.languageOption = '[language-option]';
    this.countryItem = '[country-item]';
    this.countryInput = '[country-input]';
    this.languageInput = '[language-input]';
    this.regionExpanded = '[region-expanded]';
    this.regionItemDesktop = '[region-item-desktop]';
    this.regionItem = '[region-item]';
    this.regionItemContent = '[region-item-content]';
    this.countryName = '[country-name]';
    this.countriesList = '[countries-list]';
    this.isMobile = this.getAttribute('is_mobile') === 'true';
  }

  getElements() {
    return {
      modalTriggerBtn: document.getElementById('meraki-locale-mobile-trigger'),
      modalPopupNode: this.querySelector('[modal-popup-node]'),
      searchInputNode: this.querySelector('[search-input-node]'),
      searchInputNodeDesktop: this.querySelector('[search-input-desktop]'),
      formNode: this.querySelector('[form-node]'),
      modalContent: this.querySelector('[modal-content]'),
      closeButton: this.querySelector('[close-button]'),
      searchClear: this.querySelector('[search-clear]'),
      appleContentScript: this.querySelector('.apple-locale-modal-mobile-content')
    }
  }

  connectedCallback() {
    this.element = this.getElements();
    // 语言选择器弹窗
    if (!this.element.modalPopupNode) return;

    if (this.element.modalTriggerBtn && this.isMobile) {
      // 点击弹窗触发按钮，加载语言选择器内容
      this.element.modalTriggerBtn.addEventListener('click', (event) => {
        this.initHtml();
      })
    }

    if (this.element.modalPopupNode) {
      this.element.modalPopupNode.addEventListener('click', (event) => {
        // 执行顺序最好不变
        this.handleLangSwitch(event);
        this.handleCountrySwitch(event);
        this.handleMobileViewSwitch(event);
        this.handleDesktopViewSwitch(event);
      })
      
      this.handleInputSearch();
    };
    
    this.close();
  }

  handleLangSwitch(event) {
    // 点击切换语言
    const langOptionNode = event.target.closest(this.languageOption);
    if (langOptionNode) {
      if (window.merakiUtils && window.merakiUtils.localStorageSet) window.merakiUtils.localStorageSet();
      const countryCode = langOptionNode.dataset.country;
      const languageCode = langOptionNode.dataset.language;

      const parentButDom = langOptionNode.closest(this.countryItem);
      const redirectPath = parentButDom.dataset.redirectPath;
      const currencyCode = parentButDom.dataset.currencyCode;
      if (parentButDom.getAttribute('data-action') === 'default') {
        if (window.merakiUtils && window.merakiUtils.submitCountryForm && window.merakiUtils.filterRedirectPath) {
          const returnHref = window.merakiUtils.filterRedirectPath(redirectPath)
          window.merakiUtils.submitCountryForm(countryCode, returnHref, languageCode, currencyCode)
        }
        return;
      }

      if (this.element.formNode) {
        const countryInput = this.element.formNode.querySelector(this.countryInput);
        const languageInput = this.element.formNode.querySelector(this.languageInput);
        // 这里是站内跳转的特殊处理，对 CA AUS EU 等站点做处理
        if (window.merakiUtils && window.merakiUtils.formatReturnHref) {
          const returnHrefDom = this.element.formNode.querySelector('input[name="return_to"]');
          let returnTo = returnHrefDom ? returnHrefDom.value : '';
          returnTo = window.merakiUtils.formatReturnHref(returnTo, countryCode);
          returnHrefDom.value = returnTo;
        }

        if (!countryCode || !languageCode) return;
        countryInput.value = countryCode;
        languageInput.value = languageCode;
        this.element.formNode.submit();
      }
      return;
    }
  }

  handleCountrySwitch(event) {
    // 切换国家
    const countryNode = event.target.closest(this.countryItem);
    if (countryNode) {
      if (window.merakiUtils && window.merakiUtils.localStorageSet) window.merakiUtils.localStorageSet();

      const countryCode = countryNode.dataset.country;
      const defaultLang = window.Shopify?.locale || 'en';

      const redirectPath = countryNode.dataset.redirectPath;
      const currencyCode = countryNode.dataset.currencyCode;

      if (countryNode.getAttribute('data-action') === 'default') {
        if (window.merakiUtils && window.merakiUtils.submitCountryForm && window.merakiUtils.filterRedirectPath) {
          const returnHref = window.merakiUtils.filterRedirectPath(redirectPath)
          window.merakiUtils.submitCountryForm(countryCode, returnHref, defaultLang, currencyCode)
        }
        return;
      }

      if (!countryCode || !defaultLang) return;
      if (this.element.formNode) {
        const countryInput = this.element.formNode.querySelector('input[name="country_code"]');
        const localeInput = this.element.formNode.querySelector('input[name="locale_code"]');
        if (countryInput && localeInput) {
          countryInput.value = countryCode;
          localeInput.value = defaultLang;
          // 这里是站内跳转的特殊处理，对 CA AUS EU 等站点做处理
          if (window.merakiUtils && window.merakiUtils.formatReturnHref) {
            const returnHrefDom = this.element.formNode.querySelector('input[name="return_to"]');
            let returnTo = returnHrefDom ? returnHrefDom.value : '';
            returnTo = window.merakiUtils.formatReturnHref(returnTo, countryCode)
            returnHrefDom.value = returnTo;
          }
          this.element.formNode.submit();
        }
      }
      return;
    }
  }

  handleMobileViewSwitch(event) {
    // 移动端点击区域按钮，展开/收起该区域的国家列表
    const regionExpandedNode = event.target.closest(this.regionExpanded);
    if (regionExpandedNode) {
      const region = regionExpandedNode.dataset.region;
      const countriesContainer = this.element.modalPopupNode.querySelector(`[data-region-content="${region}"]`);
      if (!countriesContainer) return;
      const isExpanded = countriesContainer.classList.contains('expanded');
      if (isExpanded) {
        countriesContainer.classList.remove('expanded');
        regionExpandedNode.classList.remove('expanded');
      } else {
        this.element.modalPopupNode.querySelectorAll(this.regionItem).forEach(container => {
          container.querySelector(this.regionExpanded).classList.remove('expanded');
          container.querySelector(this.regionItemContent).classList.remove('expanded');
        });
        countriesContainer.classList.add('expanded');
        regionExpandedNode.classList.add('expanded');
      }
      return;
    }
  }

  handleDesktopViewSwitch(event) {
    // PC 端切换区域
    const regionItemNode = event.target.closest(this.regionItemDesktop);
    if (regionItemNode) {
      const region = regionItemNode.dataset.region;
      this.regionDesktopButtons.forEach(btn => {
        if (btn.dataset.region === region) {
          btn.classList.add('active');
        } else {
          btn.classList.remove('active');
        }
      });
      
      this.countryItemNodes.forEach(item => {
        const itemRegion = item.dataset.region;
        if (region === 'common') {
          item.removeAttribute('hidden');
        } else {
          if (itemRegion === region) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
          }
        }
        if (this.countriesListNode) {
          if (region === 'north-america') {
            this.countriesListNode.classList.add('sort')
          } else {
            this.countriesListNode.classList.remove('sort')
          }
        }
      });
      if (this.element.searchInputNodeDesktop) {
        if (this.element.searchInputNodeDesktop.value.trim() !== '') {
          this.handleSearch(this.element.searchInputNodeDesktop.value);
        }
      }
      return;
    }
  }

  handleInputSearch() {
    if (this.element.searchInputNode) {
      this.element.searchInputNode.addEventListener('input', (e) => {
        const inputValue = e.target.value;
        const term = inputValue.toLowerCase().trim();
        const searchLoadingClass = 'is-loading'
        if (this.element.modalContent && !this.element.modalContent.classList.contains(searchLoadingClass)) {
          this.element.modalContent.classList.add(searchLoadingClass)
        }
        const localeCommonItems = this.element.modalPopupNode.querySelectorAll(`[data-region-content="Common"] ${this.countryItem}`);
        if (term === '') {
          localeCommonItems.forEach(item => {
            item.removeAttribute('hidden')
          })
          this.element.modalContent.classList.remove(searchLoadingClass)
          this.element.searchClear.style.display = 'none';
          
          this.countryItemNodes.forEach(item => {
            item.style.display = 'flex';
          });
          return;
        }

        localeCommonItems.forEach(item => {
          const counryName = item.querySelector(this.countryName)
          if (counryName) {
            const text = counryName.textContent.toLowerCase()
            if (text.includes(term)) {
              item.removeAttribute('hidden')
            } else {
              item.setAttribute('hidden', true)
            }
          }
        })
      });
    }

    if (this.element.searchInputNodeDesktop) {
      this.element.searchInputNodeDesktop.addEventListener('input', (e) => {
        const inputValue = e.target.value;
        this.handleSearch(inputValue);
      });
    }
  }

  close() {
    // 点击关闭按钮，关闭弹窗
    if (this.element.closeButton) {
      this.addEventListener('click', (e) => {
        if (!e.target.closest('[close-button]')) return;
        this.element.modalPopupNode.setAttribute('hidden', '');
        document.body.style.overflow = '';
        document.body.classList.remove(this.openClass);
      });
    }
  }

  handleSearch(inputValue) {
    const term = inputValue.toLowerCase().trim();

    this.countryItemNodes.forEach(item => {
      const counryName = item.querySelector(this.countryName)
      if (counryName) {
        const text = counryName.textContent.toLowerCase()
        if (text.includes(term)) {
          item.removeAttribute('hidden')
        } else {
          item.setAttribute('hidden', true)
        }
      }
    });
  }

  initHtml() {
    if (!this.element.modalPopupNode) return;
    // 加载语言选择器内容
    if (!this.isInitHtml && this.element.appleContentScript && this.element.modalContent) {
      this.isInitHtml = true;
      const appleContentScriptText = this.element.appleContentScript.textContent;
      this.element.modalContent.innerHTML = appleContentScriptText;

      this.getItems();
    }

    this.element.modalPopupNode.removeAttribute('hidden');
    this.element.modalPopupNode.style.display = 'flex';
    document.body.classList.add(this.openClass);
  }

  open() {
    if (this.element.modalPopupNode) {
      this.initHtml();
      this.element.modalPopupNode.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      let focusTimeout = setTimeout(() => {
        this.element.searchInputNodeDesktop.focus();
        clearTimeout(focusTimeout);
        focusTimeout = null;
      }, 100);
    }
  }

  getItems() {
    if (this.element.modalPopupNode) {
      this.countryItemNodes = this.element.modalPopupNode.querySelectorAll(this.countryItem);
      this.regionDesktopButtons = this.element.modalPopupNode.querySelectorAll(this.regionItemDesktop);
      this.countriesListNode = this.element.modalPopupNode.querySelector(this.countriesList);
    }
  }

  disconnectedCallback() {
  }
}
customElements.define('meraki-region-picker', RegionPicker);
